import React from 'react'
import './Footer.css'
import { IconButton } from '@mui/material'
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import MailIcon from '@mui/icons-material/Mail';
export default function Footer() {
  
  return (
    <div className='Footer'>
        <div>
            <h3>RAM</h3>
      </div>
      <div className='footet'>
        <span className='atra'>&copy;</span>
      <p className='foott'>rammathala. All rights reserved</p> 
      </div>
      <div className='social'>
        <a href='https://www.linkedin.com/in/ram-mathala/' target={'_blank'} rel="noopener noreferrer" ><IconButton className='i'><LinkedInIcon className='i1'/></IconButton></a>
        <a href='https://github.com/rammathala'  target='_blank' rel="noopener noreferrer"><IconButton className='i'><GitHubIcon className='i1'/></IconButton></a>
        <a href="mailto:rammathala@gmail.com"  target='_blank'rel="noopener noreferrer"><IconButton className='i'><MailIcon className='i1'/></IconButton></a>

       </div>
    </div>
  )
}
